<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_ca9"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="receivables_search_button" @click="funcFilter()">
          查询
        </el-button>
        <el-button v-if="receivables_export_button" @click="funcExport()">
          导出
        </el-button>
        <el-button v-if="receivables_statement_button" @click="Statement()">
          生成对账单
        </el-button>
        <template v-if="balance">
          <el-button
            v-if="receivables_mybankBalance_button"
            type="primary"
            @click="goToPage('/basicInfo/InternetBanking/MerchantNanagement')"
          >
            网商余额: {{ balance.mybankBalance }}
          </el-button>
          <el-button v-if="receivables_creditBalance_button" type="primary">
            剩余授信: {{ balance.creditBalance }}
          </el-button>
          <el-button
            v-if="receivables_platformBalance_button"
            type="primary"
            @click="goToPage('/basicInfo/account/Balance')"
          >
            平台余额: {{ balance.platformBalance }}
          </el-button>
        </template>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      row-id="id"
      height="80%"
      :footer-method="footerMethod"
      :loading="loading"
      :data="tableData"
      :checkbox-config="{
        highlight: true,
        strict: true,
        checkMethod: checCheckboxkMethod
      }"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="260"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="companyName"
          title="所属企业"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.companyName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="partyType != 'SHIPMENT' && partyType != 'SHIPMENT_COMPANY'"
      >
        <vxe-table-column
          field="shipperDeliveryFee"
          title="应付运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!--      <vxe-table-column>-->
      <!--        <vxe-table-column field="shipperDeliveryFee" title="信息费" min-width="200" sortable />-->
      <!--        <template v-slot:header>-->
      <!--          <el-row>-->
      <!--            <el-col :span="11">-->
      <!--              <el-input type="number" v-model="listQuery.shipperDeliveryFeeStart" placeholder="下限" clearable />-->
      <!--            </el-col>-->
      <!--            <el-col :span="11" :offset="2">-->
      <!--              <el-input type="number" v-model="listQuery.shipperDeliveryFeeEnd" placeholder="上限" clearable />-->
      <!--            </el-col>-->
      <!--          </el-row>-->
      <!--        </template>-->
      <!--      </vxe-table-column>-->
      <vxe-table-column
        v-if="partyType === 'SHIPMENT' || partyType === 'SHIPMENT_COMPANY'"
      >
        <vxe-table-column
          field="upShipmentName"
          title="上游客户"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.upShipmentName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-if="partyType === 'SHIPMENT' || partyType === 'SHIPMENT_COMPANY'"
      >
        <vxe-table-column
          field="inFee"
          title="应收运费"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.inFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.inFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperAddress"
          title="装货地"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipperAddress"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneeAddress"
          title="卸货地"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consigneeAddress"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="driverName"
          title="承运实际承运人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.driverName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="下单时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getLimit } from "@/utils/getLimit.js";
import {
  translateAccount,
  collectionAccountCheck,
  balance
} from "@/api/category";
export default {
  data() {
    return {
      exportObj: {
        exportUrl:
          "/ntocc-tms-api/collectionAccountCheck/exportTranslateAccount", //导出接口
        name: "收款对账"
      },
      loading: false,
      receivables_search_button: false, //查询
      receivables_export_button: false, //导出
      receivables_statement_button: false, //生成对账单
      receivables_mybankBalance_button: false, //网商余额
      receivables_creditBalance_button: false, //剩余授信
      receivables_platformBalance_button: false, //平台余额
      tableData: [],
      arrduiz: [],
      listQuery: {
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      billType: "",
      partyType: "",
      balance: "",
      // 机构列表
      branchList: this.$store.state.components.branchList,
      branchCode: this.$store.state.user.party.branchCode
    };
  },
  created() {
    this.partyType = this.$store.getters.party.partyType;
    this.findList();
    this.getBalance();
    this.receivables_search_button = getLimit("receivables_search_button");
    this.receivables_export_button = getLimit("receivables_export_button");
    this.receivables_statement_button = getLimit(
      "receivables_statement_button"
    );
    this.receivables_mybankBalance_button = getLimit(
      "receivables_mybankBalance_button"
    );
    this.receivables_creditBalance_button = getLimit(
      "receivables_creditBalance_button"
    );
    this.receivables_platformBalance_button = getLimit(
      "receivables_platformBalance_button"
    );
  },
  methods: {
    getBalance() {
      return new Promise(resolve => {
        balance().then(response => {
          if (response.status === 0) {
            this.balance = response.data;
          }
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    goToPage(url) {
      if (url) {
        this.$router.push(url);
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        translateAccount(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    Statement() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
        return false;
      }
      const codes = selectRecords.map(item => item.code).join(",");
      const rLoading = this.openLoading();
      this.$refs.xTable.clearCheckboxRow();
      collectionAccountCheck(codes, this.billType).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.findList();
      });
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    },
    checCheckboxkMethod({ row }) {
      return row.branchCode == this.branchCode;
    }
  }
};
</script>
